<script lang="ts">
    import type { TileListInitialSession } from '@tilelist/application/core/TileListInitialSession.ts';
    import { createTileListPageBrowserLifecycle } from '@tilelist/application/wiring/tile-list-page/TileListPageBrowserLifecycle.browser.ts';
    import TileListController from '@tilelist/components/tile-list-controller/TileListController.svelte';
    import TileListPageView from './TileListPageView.svelte';

    const { initialSession }: { initialSession: TileListInitialSession } = $props();
</script>

<TileListController {initialSession} createBrowserLifecycle={createTileListPageBrowserLifecycle}>
    {#snippet children(controller)}
        <TileListPageView {initialSession} {...controller} />
    {/snippet}
</TileListController>
